
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea579"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea579"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8ys6G", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $63a74d272ad07654$export$6503ec6e8aabbaf; }, function (v) { return $63a74d272ad07654$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $63a74d272ad07654$export$f7ad0328861e2f03; }, function (v) { return $63a74d272ad07654$export$f7ad0328861e2f03 = v; });
var $63a74d272ad07654$export$6503ec6e8aabbaf;
var $63a74d272ad07654$export$f7ad0328861e2f03;
"use strict";
var $63a74d272ad07654$var$mapping = new Map();
function $63a74d272ad07654$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$63a74d272ad07654$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $63a74d272ad07654$var$resolve(id) {
    var resolved = $63a74d272ad07654$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$63a74d272ad07654$export$6503ec6e8aabbaf = $63a74d272ad07654$var$register;
$63a74d272ad07654$export$f7ad0328861e2f03 = $63a74d272ad07654$var$resolve;

});

parcelRegister("jNZCW", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $e6b265ccda22670e$export$bdfd709ae4826697; }, function (v) { return $e6b265ccda22670e$export$bdfd709ae4826697 = v; });
var $e6b265ccda22670e$export$bdfd709ae4826697;
var $e6b265ccda22670e$export$c9e73fbda7da57b6;
var $e6b265ccda22670e$export$5a759dc7a1cfb72a;
"use strict";
var $e6b265ccda22670e$var$bundleURL = {};
function $e6b265ccda22670e$var$getBundleURLCached(id) {
    var value = $e6b265ccda22670e$var$bundleURL[id];
    if (!value) {
        value = $e6b265ccda22670e$var$getBundleURL();
        $e6b265ccda22670e$var$bundleURL[id] = value;
    }
    return value;
}
function $e6b265ccda22670e$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $e6b265ccda22670e$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $e6b265ccda22670e$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $e6b265ccda22670e$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$e6b265ccda22670e$export$bdfd709ae4826697 = $e6b265ccda22670e$var$getBundleURLCached;
$e6b265ccda22670e$export$c9e73fbda7da57b6 = $e6b265ccda22670e$var$getBaseURL;
$e6b265ccda22670e$export$5a759dc7a1cfb72a = $e6b265ccda22670e$var$getOrigin;

});

parcelRegister("kQALy", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("kRdHQ"))((parcelRequire("8ys6G")).resolve("aEUgU")),
    (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("kh6Xy"))
]).then(()=>parcelRequire("dPWFN"));

});
parcelRegister("kRdHQ", function(module, exports) {
"use strict";

var $86uf3 = parcelRequire("86uf3");
module.exports = $86uf3(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

});
parcelRegister("86uf3", function(module, exports) {
"use strict";
var $5e6657a4c050a44a$var$cachedBundles = {};
var $5e6657a4c050a44a$var$cachedPreloads = {};
var $5e6657a4c050a44a$var$cachedPrefetches = {};
function $5e6657a4c050a44a$var$getCache(type) {
    switch(type){
        case "preload":
            return $5e6657a4c050a44a$var$cachedPreloads;
        case "prefetch":
            return $5e6657a4c050a44a$var$cachedPrefetches;
        default:
            return $5e6657a4c050a44a$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $5e6657a4c050a44a$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRegister("fdh9B", function(module, exports) {
"use strict";

var $86uf3 = parcelRequire("86uf3");
module.exports = $86uf3(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Add a global function to handle when the script loads.
        var globalName = "i".concat(("" + Math.random()).slice(2));
        $parcel$global[globalName] = function(m) {
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        var cleanup = function() {
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        var script = document.createElement("script");
        script.async = true;
        script.type = "module";
        script.charset = "utf-8";
        script.textContent = "import * as m from '".concat(bundle, "'; ").concat(globalName, "(m);");
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});


parcelRegister("7X67o", function(module, exports) {


module.exports = (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("bsivy")).then(()=>parcelRequire("a3T36"));

});

parcelRegister("cH9Dv", function(module, exports) {


module.exports = (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("5P3ib")).then(()=>parcelRequire("eXwdc"));

});

parcelRegister("7MgeO", function(module, exports) {


module.exports = (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("iTNrm")).then(()=>parcelRequire("Um6nd"));

});

parcelRegister("3Lvaw", function(module, exports) {


module.exports = (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("85Wgp")).then(()=>parcelRequire("clx5f"));

});

parcelRegister("6ZfIa", function(module, exports) {


module.exports = (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("MAvEK")).then(()=>parcelRequire("bjU9y"));

});

var $32cc36b8bef060d0$exports = {};


(parcelRequire("8ys6G")).register((parcelRequire("jNZCW")).getBundleURL("2NZQs"), JSON.parse('["2NZQs","as-modern.js","kh6Xy","swiper.5cad10e2.js","aEUgU","swiper.21b425bc.css","bsivy","eyeAble.d31aa772.js","5P3ib","mainNavHandler.1c887704.js","iTNrm","ce_contact_popup.b6bb4b80.js","85Wgp","sectionNav.73c14358.js","MAvEK","blogLatestFilter.f8356e29.js"]'));

// ====================================================================================
// Main Entry Point - Prioritized Module Loading
// ====================================================================================
const $c650d1302b554f6f$export$d680cb6eec13a7c7 = ()=>new Promise((resolve)=>{
        if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", resolve, {
            once: true
        });
        else resolve();
    });
const $c650d1302b554f6f$export$be1257a3a9248b22 = ()=>new Promise((resolve)=>{
        if ("requestIdleCallback" in window) requestIdleCallback(resolve, {
            timeout: 1000
        });
        else setTimeout(resolve, 100);
    });


// =========================================================================
// Cache selectors for better performance
// =========================================================================
const $d24485f84e15129c$var$swiper = document.querySelector(".swiper-container") || document.querySelector(".numbers-swiper");
const $d24485f84e15129c$var$eyeAble = document.querySelector(".btn--contrast");
const $d24485f84e15129c$var$mainNav = document.querySelector("#main-nav1");
const $d24485f84e15129c$var$contactPopupItems = document.querySelectorAll(".ctype-ce_contact_popup");
const $d24485f84e15129c$var$sectionNav = document.querySelector(".section-nav");
const $d24485f84e15129c$var$blogLatestFilters = document.querySelector(".blog-latest__filters");
// =========================================================================
// CRITICAL: Load immediately (blocking)
// =========================================================================
const $d24485f84e15129c$var$criticalImports = [];
// Add critical imports here
if ($d24485f84e15129c$var$criticalImports.length) Promise.all($d24485f84e15129c$var$criticalImports).catch(console.error);






// =========================================================================
// HIGH PRIORITY: Load after DOM ready
// =========================================================================
(0, $c650d1302b554f6f$export$d680cb6eec13a7c7)().then(()=>{
    const imports = [];
    // Add high priority imports here
    if ($d24485f84e15129c$var$swiper) imports.push((parcelRequire("kQALy")).then((m)=>m.init()));
    if ($d24485f84e15129c$var$eyeAble) imports.push((parcelRequire("7X67o")).then((m)=>m.init()));
    if ($d24485f84e15129c$var$mainNav) imports.push((parcelRequire("cH9Dv")).then((m)=>m.init()));
    if ($d24485f84e15129c$var$contactPopupItems.length > 0) imports.push((parcelRequire("7MgeO")).then((m)=>m.init()));
    if ($d24485f84e15129c$var$sectionNav) imports.push((parcelRequire("3Lvaw")).then((m)=>m.init()));
    if ($d24485f84e15129c$var$blogLatestFilters) imports.push((parcelRequire("6ZfIa")).then((m)=>m.init()));
    if (imports.length) Promise.all(imports).catch(console.error);
});
// =========================================================================
// LOW PRIORITY: Load when browser is idle
// =========================================================================
(0, $c650d1302b554f6f$export$be1257a3a9248b22)().then(()=>{
    const imports = [];
    // Add low priority imports here
    if (imports.length) Promise.all(imports).catch(console.error);
});


//# sourceMappingURL=as-modern.js.map
